module.exports = " <footer fxLayout=\"row\"\n         fxLayoutAlign=\"center start\"\n         fxFlex=\"90\"\n         fxFlex.xs=\"90\"\n         fxFlex.sm=\"80\">\n\n    <div class=\"footerContent\" [innerHTML]=\"data.footer | safeHtml\">\n\n    </div>\n\n  </footer>\n"


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/src/app/footer/footer.component.html
// module id = ../../../../../src/app/footer/footer.component.html
// module chunks = 0